import 'reflect-metadata';
import { container } from 'tsyringe';
import { TaxDataSource, LocalDatabaseDataSource, AuthDataSource, GoogleMapDataSource, ImoryApiDataSource, FirestoreDataSource, CloudStorageDataSource, } from '../model/repository/data_source';
// Repository bind DataSource
container.register('TaxRepository', { useClass: TaxDataSource });
container.register('LocalDatabaseRepository', { useClass: LocalDatabaseDataSource });
container.register('AuthRepository', { useClass: AuthDataSource });
container.register('GoogleMapRepository', { useClass: GoogleMapDataSource });
container.register('ImoryApiRepository', { useClass: ImoryApiDataSource });
container.register('FirestoreRepository', { useClass: FirestoreDataSource });
container.register('CloudStorageRepository', { useClass: CloudStorageDataSource });
export default container;
